import type { Locale } from '@multaqa/i18n'

const regionNames = new Map<Locale, Intl.DisplayNames>()

export function regionName(code: string | null | undefined, locale: Locale): string {
  if (code == null) return ''

  let displayNames = regionNames.get(locale)
  if (!displayNames) {
    displayNames = new Intl.DisplayNames(locale, { type: 'region' })
    regionNames.set(locale, displayNames)
  }

  const iso = code.trim().toUpperCase()
  if (!/^[A-Z]{2}$/.test(iso)) return code
  return displayNames.of(iso) ?? code
}
